/**
 * ACARI パスワードページ - 波紋エフェクト生成スクリプト
 * ランダムな位置に波紋を表示
 */

(function() {
    'use strict';
    
    // ページ読み込み完了後に実行
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initRipples);
    } else {
        initRipples();
    }
    
    function initRipples() {
        // 波紋を5個生成（間隔を広げる）
        for (let i = 0; i < 5; i++) {
            createRipple(i);
        }
    }
    
    function createRipple(index) {
        const ripple = document.createElement('div');
        ripple.className = 'acari-ripple';
        
        // ランダムな位置(画面全体の10%〜90%の範囲)
        const randomLeft = Math.random() * 80 + 10;
        const randomTop = Math.random() * 80 + 10;
        ripple.style.left = randomLeft + '%';
        ripple.style.top = randomTop + '%';
        ripple.style.transform = 'translate(-50%, -50%)';
        
        // 間隔を広げる（5秒ごとに1つずつ開始）
        ripple.style.animationDelay = (index * 5) + 's';
        
        document.body.appendChild(ripple);
    }
})();
